import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allClients } from 'app/mocks/data/park/clients'
import { allServices } from 'app/mocks/data/users/services'

import { api } from 'app/utils/constants'

import { Service, ServicePayload } from 'app/types/users/service'

export const updateService = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.services.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = ServicePayload.safeParse(payload)

        const serviceFound = allServices.find(
            (service) => service.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!serviceFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Service>({
            ...serviceFound,
            ...payloadParsed.data,
            client: allClients.find(
                (client) => client.id === payloadParsed.data.client,
            ),
        })
    },
)
